<template>
    <div :class="['abonement', `abonement-index-${index}`, `abonement-id-${subscription.idsubscription}`, {'active' : active}]"
         @click="selected">
        <CoursePresents v-if="showPresents"
                        @more="bonusCourseClick"
                        @close="showPresents = false"
                        :courses="subscription.courses"
        />
        <span class="abonemet-radio"></span>
        <div class="abonement-title">{{ title }}</div>
        <div class="abonement-duration">{{ subscription.subscription }}</div>
        <div class="abonement-price">{{ price }}</div>
        <div class="abonement-price-before">{{ priceBefore }}</div>
        <div class="abonement-price-lesson">{{ subscription.description }}</div>
        <div class="abonement-course-bonus" v-if="subscription.courses && subscription.courses.length > 0">
            <span :title="courseBonusTitle" @click.stop="showPresents = !showPresents"><img
                    src="@/assets/hometeacher/images/course-present.png"><span><span
                    v-if="subscription.courses && subscription.courses.length > 1">{{ $t('courses') }}</span><span
                    v-else>{{ $t('course') }}</span> {{ $t('as_gift') }}!</span></span>
        </div>
        <base-button v-if="!hideOrderButton" class="mt-lg-3 mt-1 w-100 red-btn" @click.stop="order"
                     :disabled="disableOrderIfNotActive && !active"
                     :data-id="subscription.idsubscription"
                     data-model="subscription"
                     :data-price="subscription.price"
                     data-action="order"
                     :data-label="orderTitle">
            {{ orderTitle }}
        </base-button>
        <base-checkbox v-if="showRecurrentParam" class="custom-control-alternative danger" v-model="recurrentParam"
                       @input="recurrentParamUpdate">
            {{ $t('reccurent_notice') }}
        </base-checkbox>
    </div>
</template>

<script>
    import numeral from 'numeral';
    import CoursePresents from "../CourseComponents/present/CoursePresents";
    import i18n from './../../i18n';

    export default {
        name: "SubscriptionItem",
        components: {CoursePresents},
        props: {
            subscription: {type: Object},
            title: {type: String, default: i18n.t('subscription')},
            orderTitle: {type: String, default: i18n.t('sign_up')},
            index: {type: Number, default: null},
            active: {type: Boolean, default: false},
            disableOrderIfNotActive: {type: Boolean, default: false},
            hideOrderButton: {type: Boolean, default: false},
            showRecurrentParam: {type: Boolean, default: false},
        },
        data() {
            return {
                recurrentParam: false,
                showPresents: false,
            }
        },

        mounted() {
            if (this.showRecurrentParam) {
                this.recurrentParam = true
            }
            this.$emit("recurrentParamUpdate", this.recurrentParam);
        },

        watch: {
            showRecurrentParam(val) {
                this.recurrentParam = val
                this.$emit("recurrentParamUpdate", this.recurrentParam);
            },
        },

        methods: {
            selected() {
                this.$emit("selected", this.subscription);
            },

            order() {
                this.$emit("order", this.subscription);
            },

            bonusCourseClick() {
                this.$emit("bonusCourseClick", this.subscription);
            },

            recurrentParamUpdate() {
                this.$emit("recurrentParamUpdate", this.recurrentParam);
            },

        },

        computed: {
            price() {
                if (this.subscription.price && this.subscription.price > 0) return numeral(this.subscription.price).format("0,0").replace(/,/g, '\u00A0') + '\u00A0' + this.$t('cur')
                return this.$t('free');
            },

            priceBefore() {
                if (this.subscription.pricebefore && this.subscription.pricebefore > 0) return numeral(this.subscription.pricebefore).format("0,0").replace(/,/g, '\u00A0') + '\u00A0' + this.$t('cur')
                return null;
            },

            courseBonusTitle() {
                if (this.subscription.courses && this.subscription.courses.length > 0) {
                  let courseNames = this.subscription.courses.map(c => c.course);
                    return "Купите абонемент и получите в подарок: \u000d" + courseNames.join(",\u000d ")
                }
                return "";
            },
        },

        filters: {}

    }
</script>

<style scoped>

    .abonement-course-bonus {
        text-align: center;
        cursor: pointer;
        font-family: "Manrope Bold";
        color: #ed1c24;
        position: absolute;
        right: -43px;
        top: 45px;
        transform: rotate(45deg);
        padding: 0 5px;
        background-image: url('~@/assets/hometeacher/images/course-present-bg.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 206px;
        height: 30px;
    }

    .abonement-course-bonus > span {
        font-size: 16px;
        padding-top: 0px;
        padding-bottom: 3px;
        padding-left: 4px;
        padding-right: 4px;
    }

    .abonement-course-bonus > span > span {
        border-bottom: dashed 1px;
    }

    .abonement-course-bonus > span > img {
        margin-right: 4px;
        margin-bottom: 2px;
    }

    .abonement-price-before, .abonement-price-lesson {
        min-height: 24px;
    }

    .abonement {
        border-radius: 10px;
        border: 1px solid #d7e1e5;
        min-height: 234px;
        padding: 14px 26px;
        position: relative;
        cursor: pointer;
    }

    .abonement.disabled {
        cursor: no-drop;
    }

    .abonement.active {
        box-shadow: 3px 3px 7px 1px #bbb7b763;
    }

    .abonement-title {
        font-size: 14px;
        font-family: Manrope Bold;
        color: #8b8496;
    }

    .abonement-duration {
        color: #de0035;
        font-size: 24px;
        font-family: Manrope Bold;
    }

    .abonement-price {
        color: #231c37;
        font-size: 30px;
        font-family: Manrope Bold;
    }

    .abonement-price-before {
        color: #4f4d5c;
        font-size: 16px;
        text-decoration: line-through;
    }

    .abonement-price-lesson {
        color: #8b8496;
        font-family: Manrope Bold;
        font-size: 15px;
    }

    .abonemet-radio {
        position: absolute;
        display: block;
        border: 1px solid #b8c7d9;
        height: 30px;
        width: 30px;
        right: 15px;
        border-radius: 50%;
    }

    .active.abonement .abonemet-radio::after {
        display: block;
    }

    .abonement .abonemet-radio::after {
        background-color: #ed1c24;
        display: none;
        content: " ";
        height: 28px;
        width: 28px;
        border-radius: 50%;
        border: 6px solid white;
        padding: 1px;
        box-sizing: border-box;
    }

    .abonement-price span {
        font-size: 18px;
    }

    .red-btn {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        border-radius: 15px;
        font-size: 18px;
        color: #231c37;
        font-family: "Manrope Bold";
    }

    .red-btn:disabled, .red-btn.btn-default:disabled:hover {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        opacity: 0.8;
        color: rgba(35, 28, 55, 0.55);
        text-shadow: none;
    }

    .active .red-btn, .red-btn.btn-default:hover {
        background-color: #de0035;
        border-color: #de0035;
        color: white;
        text-shadow: 1px 1px 2px #97191e;
    }

</style>
